// generic styled components
import React, { useState, forwardRef } from "react";
import styled, { keyframes }  from "styled-components";
import { Collapse, Container } from "reactstrap";
import { useVsiAppContext } from "../stores/VsiApp";
import themeStyles from "../utils/themeStyles";
import AutobotCheckbox from "../components/AutobotCheckbox";

export const VsiApp = styled.main`
  background-color: ${(props) => props.theme.bgColor};
  min-height: 100vh;
  transition: all 0.2s ease-in-out;
`;

export const VsiContentSection = styled.section`
  margin-left: ${(props) => (props.$isOpen ? "250px" : "80px")};

  transition: all 0.3s ease;
  @media (max-width: 768px) {
    margin: 0 auto;
  }
`;

export const VsiP = styled.p`
  color: ${(props) => props.theme.textColor};
	font-size: 1rem;
	
`

export const VsiUl = styled.ul`
  color: ${(props) => props.theme.textColor};
	font-size: 1rem;
  
`

export const VsiH1 = styled.h1`
  color: ${(props) => props.color || props.theme.textColor};
`;

export const VsiH2 = styled.h2`
  color: ${(props) => props.color ||  props.theme.textColor};
`;

export const VsiH3 = styled.h3`
  color: ${(props) => props.color || props.theme.textColor};
`;

export const VsiH4 = styled.h4`
  color: ${(props) => props.color || props.theme.textColor};
`;

export const VsiH5 = styled.h5`
  color: ${(props) => props.color || props.theme.textColor};
`;

export const VsiH6 = styled.h6`
  color: ${(props) => props.color || props.theme.textColor};
`;


export const VsiSmallText = styled.span`
  text-align: ${props => props.$textAlign || 'right'};
  font-size: 0.6rem;
  word-wrap: break-word;
	color: ${props => props.color || props.theme.textColor};

  @media (max-width: 768px) {
    font-size: 0.5rem;
  }

  @media (max-width: 430px) {
    font-size: 0.4rem;
  }
`;

export const VsiMedText = styled.span`
  text-align: ${props => props.$textAlign || 'right'};
  font-size: 0.75rem;
	white-space: nowrap;
	color: ${props => props.color || props.theme.textColor};

  @media (max-width: 768px) {
    font-size: 0.7rem;
  }

  @media (max-width: 430px) {
    font-size: 0.5rem;
  }
`;

export const VsiMedLabel = styled.label`
  text-align: ${props => props.$textAlign || 'right'};
  font-size: 0.9rem;
  word-wrap: break-word;
  color: ${props => props.color || props.theme.textColor};

  @media (max-width: 768px) {
    font-size: 0.8rem;
  }

  @media (max-width: 430px) {
    font-size: 0.6rem;
  }
`

export const VsiLgText = styled.span`
  text-align: ${props => props.$textAlign || 'right'};
  font-size: 1rem;
  word-wrap: break-word;
	color: ${props => props.color || props.theme.textColor};

  @media (max-width: 768px) {
    font-size: 0.85rem;
  }

  @media (max-width: 430px) {
    font-size: 0.6rem;
  }
`;

export const VsiXLText = styled.span`
  text-align: ${props => props.$textAlign || 'right'};;
  font-size: 1.5rem;
  word-wrap: break-word;
	color: ${props => props.color || props.theme.textColor};

  @media (max-width: 768px) {
    font-size: 1.2rem;
  }

  @media (max-width: 430px) {
    font-size: 1rem;
  }
`;

export const VsiSpanText = styled.span`
	color: ${props => props.theme.textColor};
`

export const VsiButton = styled.button`
	color: ${props => props.theme.textColor};
  border-color: ${props => props.theme.textColor};
`

export const VsiHr = styled.hr`
  border: 0;
  height: 1px;
  background: ${props => props.theme.type === "dark" ? '#ccc' : '#333'};
  //background-image: -webkit-linear-gradient(left, #ccc, #333, #ccc);
  //background-image: -moz-linear-gradient(left, #ccc, #333, #ccc);
  //background-image: -ms-linear-gradient(left, #ccc, #333, #ccc);
  //background-image: -o-linear-gradient(left, #ccc, #333, #ccc);
`

export const VsiBubbleStyle = styled.section`
  width: 100%;
  background: ${props => props.theme.cardBgColor};
  padding: .5rem;
  border-radius: .5rem;
  box-shadow: 0 3.2px 7px 2px rgba(114, 114, 114, 0.22);
  -webkit-box-shadow: 0 3.2px 7px 2px rgba(114, 114, 114, 0.22);
  -moz-box-shadow: 0 3.2px 7px 2px rgba(114, 114, 114, 0.22);
  margin-bottom: .5rem;
  //display: flex;
  //flex-direction: row;
  //align-items: center;
  //justify-content: center;
`

export const VsiBubbleCaret = styled.i`
    cursor: pointer;
    color: ${props => props.theme.disabledBtnColor};
`

export const VsiBubble = forwardRef((props, ref) => {
  const [isOpen, setIsOpen] = useState(true);
  const toggle = () => setIsOpen(!isOpen);

  return (
    <VsiBubbleStyle className={props.className} style={props.style} ref={ref}>
      {!props.suppressCollapse ? (
        <Container fluid className="d-flex flex-row align-items-end justify-content-end" >
          {(!props.noAutobot) ?
            // Anything not directly nested within VsiBubble will need an autobotName prop
            <AutobotCheckbox
              children={props.children}
              path={props.path}
              passedDisplayName={props.autobotName}
              unit={props.unit}
              autobotInfo={props.autobotInfo}
              />
          : null}
          <VsiBubbleCaret className={`fa-solid fa-caret-${isOpen ? 'down' : 'up'}`} onClick={toggle}/>
        </Container>
      ) : null}
      <Collapse isOpen={isOpen}>
        {props.children}
      </Collapse>
    </VsiBubbleStyle>
  )
});

export const VsiMainBubble = styled.section`
  width: 100%;
  background: ${props => props.theme.cardBgColor};
  padding: 1rem;
  border-radius: .5rem;
  box-shadow: 0 3px 4px 0 rgba(51, 51, 51, 0.22);
  -webkit-box-shadow: 0 3px 4px 0 rgba(51, 51, 51, 0.22);
  -moz-box-shadow: 0 3px 4px 0 rgba(51, 51, 51, 0.22);
  //display: flex;
  //flex-direction: row;
  //align-items: center;
  //justify-content: center;

`

export const VsiBubbleFavs = styled.section`
  width: 100%;
  background: ${props => props.theme.cardBgColor};
  padding: 1rem;
  border-radius: .5rem;
  box-shadow: 0 3px 4px 0 rgba(51, 51, 51, 0.22);
  -webkit-box-shadow: 0 3px 4px 0 rgba(51, 51, 51, 0.22);
  -moz-box-shadow: 0 3px 4px 0 rgba(51, 51, 51, 0.22);
  max-height: 430px;
  overflow-y: hidden;
  //display: flex;
	//flex-direction: row;
	//align-items: center;
	//justify-content: center;
  
`

const fadeIn = keyframes`
  from {
    transform: scale(.25);
    opacity: 0;
  }

  to {
    transform: scale(1);
    opacity: 1;
  }
`;

const fadeOut = keyframes`
  from {
    transform: scale(1);
    opacity: 0;
  }

  to {
    transform: scale(.25);
    opacity: 1;
  }
`;

export const Fade = styled.div`
  display: inline-block;
  visibility: ${props => props.out ? 'hidden' : 'visible'};
  animation: ${props => props.out ? fadeOut : fadeIn} 1s linear;
  transition: visibility 1s linear;
`;
